








import { Component, Vue } from 'vue-property-decorator';
import { Quote } from '@/models/quote';
import { QuoteApi } from '@/api/quote-api';
import orderForm from '@/components/order-form.vue';

const quoteApi = new QuoteApi();

@Component({
    components: {
        orderForm,
    },
})
export default class CreateOrder extends Vue {
    public isLoading: boolean = true;
    public quote: Quote | null = null;

    public async mounted(): Promise<void> {
        this.isLoading = true;

        const quote = await quoteApi.fetchByIdAsync(this.$route.params.id);

        this.quote = quote;
        this.isLoading = false;
    }
    public handleOrderSaved(id: string): void {
        this.$router.push({ name: 'view-order', params: { id: id } });
    }
}
